"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFeedback(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm8.901 8.9186a.7076.7076 0 1 1 -.7076.7076.7076.7076 0 0 1 .7076-.7076zm3.5836.0711a.7076.7076 0 1 1 -.7076.7076.7076.7076 0 0 1 .7076-.7076zm-9.0187-5.8601a.6954.6954 0 1 1 -.6954.6954.6954.6954 0 0 1 .6954-.6954zm3.5219.0699a.6954.6954 0 1 1 -.6954.6954.6954.6954 0 0 1 .6954-.6954zm3.6983 10.3639a3.03132 3.03132 0 0 1 -2.6779-1.6395.33355.33355 0 0 1 .5937-.3042 2.39619 2.39619 0 0 0 2.1436 1.2768 2.34262 2.34262 0 0 0 2.0386-1.3077.33358.33358 0 0 1 .5979.296 3.00627 3.00627 0 0 1 -2.6184 1.6769c-.0262.0009-.0515.0017-.0775.0017zm.01281-8.1734c-.08679 0-.1676.02143-.25335.02552.00177-.03986.00738-.07831.00842-.11841v-.07873a5.22115 5.22115 0 1 0 -5.21619 5.20862c.0597 0 .11719-.00738.17633-.0094-.00494.09381-.028.18238-.028.27741a5.31281 5.31281 0 1 0 5.3128-5.305zm-5.3233 3.956a.656.656 0 0 1 -.13782.00976 4.14227 4.14227 0 1 1 4.1435-4.13739 1.33354 1.33354 0 0 1 -.00971.1966c-.0014.05749-.01416.11127-.01819.168a5.26789 5.26789 0 0 0 -2.04388 1.0582c-.055-.05419-.10352-.11651-.16242-.16479a2.89594 2.89594 0 0 0 -1.929-.73706h-.07869a2.95471 2.95471 0 0 0 -2.57861 1.651.32608.32608 0 0 0 .14758.43237.31909.31909 0 0 0 .44281-.1474 2.29469 2.29469 0 0 1 3.51361-.75671c.06012.048.10962.10773.1648.1615a5.2742 5.2742 0 0 0 -1.24213 2.24524c-.07122.00537-.1394.01898-.21185.02068zm5.3233 5.65332a4.30433 4.30433 0 1 1 4.312-4.30432 4.31307 4.31307 0 0 1 -4.312 4.30433z' })));
}
exports.default = SvgFeedback;
